import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ServicingFunctionIdType, ServicingPageIdType } from '@common/interfaces';
import { ServicingCommonStoreService } from '@common/services';
import { GetFareConditionsStoreService } from '@common/services/my-booking/get-fare-conditions/get-fare-conditions.service';
import { SupportModalBlockComponent } from '@lib/components/support-class';
import { CommonLibService } from '@lib/services';
import { Store } from '@ngrx/store';
import { FareConditionsResponseData, GetOrderResponseData } from 'src/sdk-servicing';

@Component({
  selector: 'asw-payment-detail',
  templateUrl: './payment-detail.component.html',
})
export class PaymentDetailComponent extends SupportModalBlockComponent {
  public modalId: string = '';
  public modalIdS02P020: string = `${ServicingFunctionIdType.SERVICE_REQUEST}-${ServicingPageIdType.SERVICE_REQUEST_PAYMENT_INPUT}`;
  public modalIdS01P031: string = `${ServicingFunctionIdType.BOOKING_CONFIRMATION}-${ServicingPageIdType.MYBOOKING_ITINERARY}`;

  constructor(
    private _common: CommonLibService,
    private _fareConditionsStoreService: GetFareConditionsStoreService,
    private _servicingCommonStoreService: ServicingCommonStoreService,
    private readonly _store: Store,
    private readonly _router: Router
  ) {
    super(_common);
    this.closeWithUrlChange(this._router);
  }

  init(): void {
    const aswCommonData = this._common.aswCommonStoreService.aswCommonData;
    this.modalId = `${aswCommonData.functionId ?? ''}-${aswCommonData.pageId ?? ''}`;

    this._fareConditionsStoreService.getFareConditionsObservable().subscribe((getFareConditionsState) => {
      const fareConditions = getFareConditionsState?.model?.data ?? ({} as FareConditionsResponseData);
      this.payload.data.fareConditions = fareConditions;
    });

    this._servicingCommonStoreService.getServicingCommonModel$().subscribe((servicingCommon) => {
      const pnr = (servicingCommon.getOrder as GetOrderResponseData) ?? ({} as GetOrderResponseData);
      this.payload.data.orderData = pnr;
    });
  }

  /** (25) 閉じる(支払情報詳細モーダル)」ボタン押下時	 */
  // (17) 閉じるボタン押下処理 ※支払詳細モーダル
  closeEventHandler() {
    // (17.1) 支払詳細モーダルを閉じる。
    this.close();
  }

  reload(): void {
    /* override abstract reload function of base class */
  }

  destroy(): void {
    /* override abstract destroy function of base class */
  }
}
